import { AnalyticsStore } from "bernie-plugin-mobx";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { LocalizedComponentProps } from "@shared-ui/localization-context";
import { Destination } from "typings/microserviceModels/destination-discovery-map-flex-module";
import { FlexModuleModelStore } from "stores/FlexModuleModelStore";
import { ExtendedTemplateComponent } from "src/stores/ExperienceTemplateStore/typings";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export interface DestinationDiscoveryMapProps extends ComponentProps {
  templateComponent: ExtendedTemplateComponent;
  flexModuleModelStore: FlexModuleModelStore;
}

export interface Attribution {
  attributionAltText: string;
  attributionText: any;
}

export interface MapProps {
  staticMap: string;
  destination: Destination;
  hotels?: MapMarker[];
  activities?: MapMarker[];
  pois?: MapMarker[];
  analytics: AnalyticsStore;
  context: ExtendedContextStore;
  maxWidthDialog: boolean;
  markers: MapMarker[];
}

export interface FullScreenMapProps {
  destination: Destination;
  pois?: MapMarker[];
  hotels?: MapMarker[];
  activities?: MapMarker[];
  analytics?: AnalyticsStore;
  context: ExtendedContextStore;
  showMap?: boolean;
  toggleMapDialog: (action: string) => (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  maxWidthDialog: boolean;
  markers: MapMarker[];
}

export interface MarkerCardContent {
  id: string;
  type: MarkerType;
  price?: string;
  link: string;
  photoUrl?: string;
  photoAlt?: string;
  attribution?: Attribution;
  title: string;
  description: string;
  buttonLabel: string;
  buttonIcon: string;
  rfrr: string;
}

export interface MapMarker {
  position: Position;
  label?: string;
  cardContent: MarkerCardContent;
  qualifiers: string[];
}

export interface MapMarkersProps {
  google?: any;
  map?: any;
  hotels?: MapMarker[];
  activities?: MapMarker[];
  pois?: MapMarker[];
  onSelect: (content: MarkerCardContent) => void;
  selectMarker: string;
  isMobile: boolean;
}

export interface Position {
  lat: number;
  lng: number;
}

export interface MapMarkerCardProps extends LocalizedComponentProps {
  showCard: boolean;
  onClose: () => void;
  content: MarkerCardContent;
  analytics?: AnalyticsStore;
}

export interface MapMarkerCardViewProps extends MapMarkerCardProps {
  isMobile: boolean;
}

export interface Landmark {
  id: string;
  title: string;
  description: string;
  onClick: () => void;
}

export interface DesktopMenuProps {
  landmarks: any[];
  title: string;
}

export interface MobileMenuProps extends DesktopMenuProps {
  toggle: () => void;
  isOpen: boolean;
}

export enum MarkerType {
  HOTEL = "hotel",
  POI = "poi",
  ACTIVITY = "activity",
}
